import ArticleLayout from "@/pages/articles/components/ArticleLayout";

export default function KuponyYoybuy() {
  return <ArticleLayout slug="kupony-yoybuy" />;
}